import { MFAReminderDialog } from "./MFAReminderDialog";
import { useMFAReminder } from "@/contexts/MFAReminderContext";

export function MFAReminderWrapper() {
  const { showMFAReminder, setShowMFAReminder } = useMFAReminder();

  return (
    <MFAReminderDialog
      open={showMFAReminder}
      onOpenChange={setShowMFAReminder}
    />
  );
}
